const {Component} = require("react");
const echo = require("services/echo");
const User = require("stores/UserStore");
const Store = require("stores/NotificationsStore");
const router = require("services/router");
const {observer} = require("mobx-react");
const {computed} = require("mobx");
const {decodeObservable} = require("helpers/object");
const {debounce} = require("helpers/throttle");

@observer
class Notifications extends Component {

	/////////////////////////////////
	// Initialization
	/////////////////////////////////

	constructor(props) {
		super(props);

		this.state = {
			open: false,
			loading: false,
		};
	}

	componentDidMount() {
		this.listen(User.attributes.id);
	}

	/////////////////////////////////
	// Accessors
	/////////////////////////////////

	@computed
	get notifications() {
		return decodeObservable(Store.collection);
	}

	@computed
	get unread() {
		return decodeObservable(Store.metadata).count.unread;
	}

	@computed
	get pagination() {
		return decodeObservable(Store.metadata).pagination;
	}

	/////////////////////////////////
	// Methods
	/////////////////////////////////

	listen(id) {
		echo.notification(id)
			.notification((notification) => {
				Store.add(notification);
				Store.metadata.count.unread++;
			});
	}

	lazyLoad = debounce(250, () => {
		if (this.pagination.page < this.pagination.pages) {
			this.setState({loading: true});
			Store.append({$page: this.pagination.page + 1})
				.then(() => {
					this.setState({loading: false});
				});
		}
	});

	toggleDropdown = () => {
		this.setState({open: !this.state.open});
	}

	read(notifications) {
		Store.read(notifications);
	}

	handleClick = (notification) => {
		this.read(notification ? [notification] : []);
		if (notification.data.link) {
			window.location.href = notification.data.link;
		}
	}

	handleScroll = (e) => {
		const el = e.target;
		const bottom = el.scrollHeight - el.scrollTop === el.clientHeight;
		if (bottom) {
			this.lazyLoad();
		}
	}

	/////////////////////////////////
	// Rendering
	/////////////////////////////////

	renderEmpty() {
		return (
			<div className='notification-item'> 
				<p>Ingen notifikationer</p>
			</div>
		);
	}

	renderNotification = (notification, index) => {
		return (
			<div onClick={() => this.handleClick(notification)} key={index} className={`notification-item ${notification.read_at === null ? 'unread' : ''}`}>
				<img src={router.url('img/icons/info.svg')} alt="Info" />
				<p>
					{notification.data.event ? (
					<span>{notification.data.event}: </span>
					) : null}
					{notification.data.msg}
				</p>
			</div>
		);
	}

	render() {
		return (
			<li>
				<a onClick={this.toggleDropdown} className={`notification ${this.unread > 0 ? 'has_notification' : ''}`}>
					<img className="normal" src={router.url("img/icons/notification.svg")} alt="Noftification" />
					<img className="active" src={router.url("img/icons/notification-active.svg")} alt="Noftification" />
					{this.unread > 0 ? (
						<p>{this.unread}</p>
					) : null}
				</a>
				<div id="notification-box" className={this.state.open ? 'active' : ''}>
					<div className="notification-box-header">
						<p>Notifikationer</p>
						<a onClick={() => this.handleClick()}>Markér alle som læst</a>
					</div>
					<div onScroll={this.handleScroll} className="notifications">
						{this.notifications.length > 0 ? (
							this.notifications.map(this.renderNotification)
						) : (
							this.renderEmpty()
						)}
						<div className={`notification-item loader ${this.state.loading ? 'loading' : ''}`}>
							<svg className="circle-loader" width="40" height="40" version="1.1" xmlns="http://www.w3.org/2000/svg">
								<circle cx="20" cy="20" r="8"/>
							</svg>
						</div>
					</div>
				</div>
			</li>
		);
	}
}

module.exports = Notifications;



// WEBPACK FOOTER //
// ./resources/js/components/backend/Notifications.js